import File from './file'
import Load from './load'
import LoadCar from './load-car'
import LoadPoint from './load-point'
import LoadTemporary from './load-temporary'
import Car from './car'
import DriverAccount from './driver-account'
import PublicAccount from './public-account'
import Setting from './setting'
import Payment from './payment'
import BankAccount from './bank-account'
import FinancialBank from './financial-bank'
import FinancialCommercialBanking from './commercial-banking'
import Transaction from './transaction'
import Poi from './poi'
import Otp from './otp'
import Credential from './credential'
import Contract from './contract'
import Reason from './reason'

export default (store) => ({
  file: new File(store),
  load: new Load(store),
  loadCar: new LoadCar(store),
  loadPoint: new LoadPoint(store),
  loadTemporary: new LoadTemporary(store),
  car: new Car(store),
  driverAccount: new DriverAccount(store),
  publicAccount: new PublicAccount(store),
  setting: new Setting(store),
  payment: new Payment(store),
  bankAccount: new BankAccount(store),
  financialBank: new FinancialBank(store),
  financialCommercialBanking: new FinancialCommercialBanking(store),
  transaction: new Transaction(store),
  poi: new Poi(store),
  otp: new Otp(store),
  credential: new Credential(store),
  contract: new Contract(store),
  reason: new Reason(store)
})
